<template>
  <div class="ccs-layout">
    <div class="ccs-layout css-12 ccs-layout--no-pad">
      <ccs-input class="ccs-6" v-model.trim="fieldsValues.finish_date"
        v-bind="fieldsDefinitions.finish_date"
        @error="(err) => setFieldError('arrival_point', err)"/>
      <ccs-input class="ccs-6" v-if="isFinishDateFilled"
        v-model.trim="fieldsValues.start_date"
        v-bind="fieldsDefinitions.start_date"
        @error="(err) => setFieldError('departure_point', err)"/>
    </div>
    <div class="ccs-layout ccs-layout--no-pad">
      <div v-if="isFinishDateFilled && !isStartDateFilled">
        <button class="ccs-button" @click="submit('general')">
          Создать общий отчет
        </button>
      </div>
      <div v-if="isFinishDateFilled && isStartDateFilled">
       <button class="ccs-button" @click="submit('detailed')">
          Создать детализированный отчет
        </button>
      </div>
      <div>
        <button class="ccs-button ccs-button--light" @click="$emit('close')">
          Отмена
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

import FormHelper from '@/mixins/FormHelper.js';

import Input from '@/components/forms/Input.vue';

export default {
  name: 'CreateReport',
  mixins: [FormHelper],
  components: {
    'ccs-input': Input,
  },
  data() {
    return {
      fieldsDefinitions: {
        start_date: {
          isValid: false,
          error: '',
          required: false,
          type: "date",
          label: "Начало периода",
          validationRules: {
            requiredFields: [ 'finish_date' ],
          }
        },
        finish_date: {
          isValid: false,
          error: '',
          required: true,
          type: "date",
          label: "Конец периода (включ.)",
        },
      },
      fieldsValues: {
        start_date: null,
        finish_date: null,
      },
    }
  },
  computed: {
    isStartDateFilled() {
      return !!this.fieldsValues.start_date;
    },
    isFinishDateFilled() {
      return !!this.fieldsValues.finish_date;
    }
  },
  methods: {
    ...mapActions('events', ['createReport']),
    async submit(report_type) {
      if (!report_type) {
        this.$toasted.error('Указан неправильный тип отчета. Обратитесь к администратору');
        return;
      }
      this.validateForm();
      if (this.isFormValid) {

        // Add 1 day to finish_date in order to make it inclusive
        let finish_date = new Date(this.fieldsValues.finish_date);
        finish_date.setDate(finish_date.getDate() + 1)

        try {
          this.$toasted.info('Запрос на создание отправлен. Не закрывайте вкладку.');

          await this.createReport({
            report_type,
            finish_date,
            start_date: this.fieldsValues.start_date,
          });
          this.$toasted.success('Отчет сгенерирован');
          this.$emit('close');
        } catch (err) {
          this.showServerValidationErrors(err);
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.ccs-button {
  margin-right: 0;
}
</style>
